// SPDX-FileCopyrightText: Szilárd Hajba
// SPDX-License-Identifier: LGPL-3.0-or-later
export function placeIntervals(intervals) {
    if (intervals.length === 0)
        return [];
    // Sort by start, then longest first at the same start so bigger events
    // take the left-most lane.
    const sorted = [...intervals].sort((a, b) => a.start - b.start || b.end - a.end);
    // Pass 1: lane assignment. `lanes[i]` = end time of the event in lane i.
    const laneEnds = [];
    const lanesByIdx = new Map();
    for (const iv of sorted) {
        let lane = laneEnds.findIndex((end) => end <= iv.start);
        if (lane === -1) {
            lane = laneEnds.length;
            laneEnds.push(iv.end);
        }
        else {
            laneEnds[lane] = iv.end;
        }
        lanesByIdx.set(iv, lane);
    }
    // Pass 2: cluster discovery. Group consecutive overlapping events.
    // Within a cluster, `totalLanes` is the max lane index + 1.
    const out = [];
    let clusterStart = 0;
    let clusterEndMax = -Infinity;
    let clusterLanes = 0;
    const flush = (fromIdx, toIdx, total) => {
        for (let i = fromIdx; i < toIdx; i++) {
            const iv = sorted[i];
            out.push({
                item: iv.item,
                lane: lanesByIdx.get(iv) ?? 0,
                totalLanes: total
            });
        }
    };
    for (let i = 0; i < sorted.length; i++) {
        const iv = sorted[i];
        if (iv.start >= clusterEndMax) {
            // Previous cluster closes.
            if (i > clusterStart)
                flush(clusterStart, i, clusterLanes);
            clusterStart = i;
            clusterEndMax = iv.end;
            clusterLanes = 1;
        }
        else {
            clusterEndMax = Math.max(clusterEndMax, iv.end);
        }
        const lane = lanesByIdx.get(iv) ?? 0;
        if (lane + 1 > clusterLanes)
            clusterLanes = lane + 1;
    }
    flush(clusterStart, sorted.length, clusterLanes);
    return out;
}
// vim: ts=4
